export default "__VITE_ASSET__BRU7hzZW__"